window['ThemeSection_header'] = (count) => {
  const dropdownCount = parseInt(count);
  const menuOpen = {};
  for (let i = 0; i < dropdownCount; i++) {
    menuOpen['menu' + i] = false;
  }

  return {
    menuOpen: menuOpen,
    searchOpen: false,
    headerIsSticky: false,
    scrollY: 0,
    navWrapped: false,
    headerHeight: 0,
    lastScrollY: 0,
    isHidden:    false,
    get isStuck() {
      return this.headerIsSticky && this.scrollY > this.headerHeight * 2;
    },
    get menuIsActive() {
      return !Object.keys(menuOpen).every((k) => !menuOpen[k]);
    },
    mounted() {
this.portal = document.querySelector('#mega-menu-portal') ||
  (() => {
    const d = document.createElement('div');
    d.id = 'mega-menu-portal';
    d.style.position = 'fixed';
    d.style.top      = 'var(--header-height)';    // ← push it down under the header
    d.style.left     = '0';
    d.style.right    = '0';
    d.style.zIndex   = '9000';                     // ← still beneath your header’s 10000
    document.body.append(d);
    return d;
  })();


  initTeleport(this.$root);

      Alpine.store('modals').register('nav', 'leftDrawer');

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          if (this.searchOpen === false) {
            for (let i = 0; i < dropdownCount; i++) {
              if (this.menuOpen['menu' + i] === true) {
                this.menuOpen['menu' + i] = false;
                document.querySelector(`[aria-controls="menu${i}"]`).focus();
              }
            }
          } else {
            if (!document.getElementById('predictiveSearchResults')) {
              document.body.dispatchEvent(
                new CustomEvent('shapes:search:closebutton')
              );
            }
          }
        }
      });

      document.body.addEventListener('shapes:search:closebutton', () => {
        this.searchOpen = false;

        this.$nextTick(() => {
          const searchToggleEl = this.$root.querySelector('[data-open-search]');

          if (searchToggleEl) {
            setTimeout(() => {
              searchToggleEl.focus();
            }, 300);
          }
        });
      });

      if (
        this.$root.hasAttribute('data-sticky-header') &&
        this.$root.hasAttribute(
          'data-transparent-when-overlay-enabled-and-stuck'
        )
      ) {
        this.setUpStickyDetection();
      }

      //set header height

      this.headerResizeFunctions();
      this._debouncedHeaderFunctions = debounce(
        this.headerResizeFunctions.bind(this),
        300
      );

      window.addEventListener('resize', this._debouncedHeaderFunctions);
      document.addEventListener('shopify:section:load', (e) => {
        if (!e.target.querySelector('.site-header')) return;
        this.headerResizeFunctions();
      });
           // ↓↓↓ TUCK-AWAY ON SCROLL: paste this entire block ↓↓↓
      let lastY   = window.pageYOffset;
      let header  = document.getElementById('site-header');
      let ticking = false;

      window.addEventListener('scroll', (e) => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentY = window.pageYOffset;
            if (currentY <= 0) {
              header.classList.remove('is-hidden');
            } else if (currentY > lastY) {
              header.classList.add('is-hidden');
            } else {
              header.classList.remove('is-hidden');
            }
            lastY   = currentY;
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
      // ↑↑↑ END TUCK-AWAY ON SCROLL ↑↑↑
    },
    headerResizeFunctions() {
      this.calculateHeaderHeight();
      this.calculateNavWrap();
    },
    setUpStickyDetection() {
      const headerContainerEl = this.$root.closest('.shopify-section');

      const sentinelEl = document.createElement('div');
      sentinelEl.setAttribute('id', 'HeaderSentinel');

      headerContainerEl.parentNode.insertBefore(sentinelEl, headerContainerEl);

      const observer = new IntersectionObserver(
        (e) => {
          e.forEach((entry) => {
            this.headerIsSticky = entry.intersectionRatio < 1 ? true : false;
          });
        },
        {
          rootMargin: '-1px 0px 0px 0px',
          threshold: [1],
        }
      );

      observer.observe(sentinelEl);

      let timer = null;

      const checkScrollPosition = (e) => {
        this.scrollY = window.scrollY;
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.scrollY = window.scrollY;
        }, 150);
      };

      const _throttledScrollHandler = throttle(checkScrollPosition, 150);
      document.addEventListener('scroll', _throttledScrollHandler);

      this.scrollY = window.scrollY;
    },
    calculateNavWrap() {
      const wrappedItems = [];
      let prevItem = {};
      let currItem = {};
      if (this.$refs.navigation !== undefined) {
        const items = this.$refs.navigation.children;
        for (var i = 0; i < items.length; i++) {
          currItem = items[i].getBoundingClientRect();
          if (prevItem && prevItem.top < currItem.top) {
            wrappedItems.push(items[i]);
          }
          prevItem = currItem;
        }
        if (wrappedItems.length > 0) {
          this.navWrapped = true;
        } else {
          this.navWrapped = false;
        }
      }
    },
    calculateHeaderHeight() {
      this.headerHeight =
        document.getElementById('headerBorderWrap').clientHeight;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );
    },
    openMenu(index) {
  // 1) mark it open
  this.menuOpen['menu' + index] = true;

  // 2) grab the exact dropdown element for this menu
  const dropdownEl = this.$root.querySelector(`[data-header-dropdown="menu${index}"] .no-js-focus-container`);
  if (dropdownEl) {
    // teleport INTO portal
    this.portal.appendChild(dropdownEl);
  }
},
focusOut(event, menu) {
  this.menuOpen['menu' + menu] = false;
  const dropdownEl = this.portal.querySelector('.no-js-focus-container');
  if (dropdownEl) {
    // Reset its inline transform so Alpine can animate it back where it belongs
    dropdownEl.style.transform = '';
    this.$root.querySelector('[data-header-bar]').appendChild(dropdownEl);
  }
}
,
    searchFocusOut() {
      this.$nextTick(() => {
        if (!this.$refs.searchFieldComponent.contains(document.activeElement))
          this.searchOpen = false;
      });
    },
    closeSearch() {
      this.searchOpen = false;
      this.$refs.search.focus();
    },
    openSearch() {
      this.searchOpen = true;
      let input = document.querySelector('.header-search-input');
      setTimeout(() => {
        input.focus();
      }, 100);
    },
  };
};
// assets/header.js

// …your existing Alpine / theme JS…

// Tuck-away on scroll:
(function() {
  var lastY   = window.pageYOffset;
  var header  = document.getElementById('site-header');
  var ticking = false;

  function onScroll() {
    var currentY = window.pageYOffset;
    if (currentY <= 0) {
      header.classList.remove('is-hidden');
    } else if (currentY > lastY) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }
    lastY = currentY;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();
